export type Theme = "light" | "dark";

export const THEME_STORAGE_KEY = "cgth-theme";

/**
 * Script chạy trước khi paint để đặt data-theme, tránh nhấp nháy (FOUC).
 * Được nhúng dạng inline trong <head>.
 */
export const themeInitScript = `
(function () {
  try {
    // Trang chủ ("/") luôn hiển thị giao diện sáng.
    if (location.pathname === '/') {
      document.documentElement.setAttribute('data-theme', 'light');
      return;
    }
    var stored = localStorage.getItem('${THEME_STORAGE_KEY}');
    var theme = stored === 'dark' || stored === 'light'
      ? stored
      : (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    document.documentElement.setAttribute('data-theme', theme);
  } catch (e) {}
})();
`;

export function getStoredTheme(): Theme | null {
  if (typeof window === "undefined") return null;
  const value = window.localStorage.getItem(THEME_STORAGE_KEY);
  return value === "dark" || value === "light" ? value : null;
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
  window.localStorage.setItem(THEME_STORAGE_KEY, theme);
}
